import React from 'react';
import { getTherapistName, formatPhoneInput } from './utils';

function GuestListStep({ selectedCenter, guestSelections, guestInfo, getTherapistPrice, onAddServicesForGuest, onCopyServicesToAll, onGuestInfoChange }) {
  // Show "copy to all" when at least one guest has services and others don't
  const firstWithServices = guestSelections.findIndex(g => g.services?.length > 0);
  const hasEmptyGuests = guestSelections.some(g => !g.services || g.services.length === 0);
  const showCopyToAll = firstWithServices >= 0 && hasEmptyGuests;

  return (
    <div className="step-content">
      <h1 className="step-title">YOUR GUESTS</h1>
      <p className="step-subtitle">{selectedCenter?.name}</p>

      {showCopyToAll && (
        <button className="btn-copy-to-all" onClick={() => onCopyServicesToAll(firstWithServices)}>
          Copy Guest {firstWithServices + 1}'s services to all guests
        </button>
      )}

      <div className="guests-list">
        {guestSelections.map((guest, idx) => (
          <div key={idx} className="guest-item guest-item-col">
            <div className="guest-item-top">
              <div className="guest-info">
                <h3>{idx === 0 ? `${guestInfo?.firstName || 'You'} (You)` : `Guest ${idx + 1}`}</h3>
                {guest.services && guest.services.length > 0 ? (
                  <div className="guest-services">
                    {guest.services.map((item, i) => (
                      <div key={i}>
                        <p>{item.service.name} with {getTherapistName(item.therapist)} — ${getTherapistPrice(item.service, item.therapist).toFixed(2)}</p>
                        {item.optionalAddOns?.map(a => <p key={a.id} className="guest-addon">+ {a.name} — ${a.price}</p>)}
                        {item.mandatoryAddOns?.map(a => <p key={a.id} className="guest-addon">+ {a.name} — ${a.price}</p>)}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="no-service">No services selected</p>
                )}
              </div>
              <button className="btn-add-service" onClick={() => onAddServicesForGuest(idx)}>
                {guest.services && guest.services.length > 0 ? 'Edit' : 'Add services'}
              </button>
            </div>

            {idx > 0 && (
              <div className="guest-info-fields">
                <input
                  type="text"
                  className="guest-field"
                  placeholder="First name"
                  value={guest.firstName || ''}
                  onChange={(e) => onGuestInfoChange(idx, 'firstName', e.target.value)}
                />
                <input
                  type="text"
                  className="guest-field"
                  placeholder="Last name"
                  value={guest.lastName || ''}
                  onChange={(e) => onGuestInfoChange(idx, 'lastName', e.target.value)}
                />
                <input
                  type="tel"
                  className="guest-field"
                  placeholder="Phone number"
                  value={guest.phone || ''}
                  onChange={(e) => onGuestInfoChange(idx, 'phone', formatPhoneInput(e.target.value))}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default GuestListStep;
